import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Broker-facing badge-only subscriber for `private_load_posted`.
 * Toast + chime are owned by useGlobalNotificationAlerts. This hook stays
 * as a lightweight no-op subscriber for parity with other role hooks and
 * to leave a hook shape ready for future badge/count needs.
 */
export function usePrivateLoadAlerts(userId: string | null | undefined, enabled: boolean) {
  useEffect(() => {
    if (!userId || !enabled) return;
    const channel = supabase.channel(`private-load-alerts-${userId}`).subscribe();
    return () => { supabase.removeChannel(channel); };
  }, [userId, enabled]);
}
